import React, { useState } from 'react';
import { Container, TextField, Button, Box, CircularProgress, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { actionButtonStyles } from '../../styles/actionButton'; // Reuse your actionButtonStyles
import { textFieldStyles } from '../../styles/textFieldStyles'; // Reuse your textFieldStyles
import axios from 'axios';

const ForgotPassword = () => {
  const { t } = useTranslation(['forms', 'buttons', 'messages']);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');  // Used for both success and error messages
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');  // Clear the message before submitting

    try {
      setLoading(true);  // Show loading spinner while the request is in progress
      const response = await axios.post('http://localhost:5000/api/reset-password/forgot-password', { email });
      setMessage(response.data);  // 'Password reset link sent'
    } catch (err) {
      setMessage(err.response?.data || 'Something went wrong');  // Handle the error
    } finally {
      setLoading(false);  // Hide loading spinner after the request completes
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box elevation={3} sx={{
        padding: 4,
        backgroundColor: "white",
        boxShadow: "0px 4px 16px rgba(0,0,0,0.1)",
        border: "none",
        borderRadius: 0,
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 2 }}>
          <img src="lp-logo.png" alt="Logo" style={{ width: '200px' }} />
        </Box>

        {message && <Alert severity={message.includes('Error') ? 'error' : 'success'}>{message}</Alert>}

        <form onSubmit={handleSubmit}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label={t('forms:email')}
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            size="small"
            sx={{ ...textFieldStyles(), marginTop: 4, marginBottom: 2 }}
          />
          
          <Button
            type="submit"
            fullWidth
            sx={actionButtonStyles()}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : t('buttons:primary.send')}
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
